var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavoriteEmptyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_1759)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7112 1.3664C19.4319 -1.11795 15.3824 0.0414161 13.1961 2.88461C11.0099 0.0414161 6.96043 -1.13175 3.68109 1.3664C1.94205 2.69139 0.848935 4.9273 0.774404 7.28743C0.6005 12.6426 4.87358 16.935 11.395 23.5185L11.5192 23.6427C12.4633 24.595 13.9166 24.595 14.8607 23.6289L14.9973 23.4909C21.5187 16.9212 25.7794 12.6288 25.6179 7.27363C25.5433 4.9273 24.4502 2.69139 22.7112 1.3664ZM13.3204 21.462L13.1961 21.6L13.0719 21.462C7.15918 15.5134 3.25875 11.5798 3.25875 7.59107C3.25875 4.83069 5.12201 2.7604 7.60636 2.7604C9.51931 2.7604 11.3826 4.12679 12.0409 6.01765H14.3638C15.0097 4.12679 16.873 2.7604 18.7859 2.7604C21.2703 2.7604 23.1335 4.83069 23.1335 7.59107C23.1335 11.5798 19.2331 15.5134 13.3204 21.462Z",
    fill: "#FCFCFC",
    fillOpacity: 0.98
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_1759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.8435,
    height: 24.8435,
    fill: "white",
    transform: "translate(0.774536)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteEmptyIcon);
export default __webpack_public_path__ + "static/media/favoriteEmptyIcon.4ac7e96c0b92a639f5ef89121e9adde4.svg";
export { ForwardRef as ReactComponent };